module.exports = __webpack_public_path__ + "img/apart02.92b71781.png";